import style from "./SegmentedCountRow.module.scss"

const { row, labelGroup, label, requiredMark, options, option, optionActive } = style

type Option<T extends string | number> = { label: string; value: T }

type Props<T extends string | number> = {
	label: string
	required?: boolean
	options: readonly Option<T>[]
	value: T | null
	onChange: (value: T) => void
}

export const SegmentedCountRow = <T extends string | number>({
	label: labelText,
	required = false,
	options: items,
	value,
	onChange,
}: Props<T>) => {
	return (
		<div className={row}>
			<div className={labelGroup}>
				<span className={label}>{labelText}</span>
				{required ? <span className={requiredMark}>*</span> : null}
			</div>
			<div className={options}>
				{items.map((item) => (
					<button
						key={String(item.value)}
						type="button"
						className={`${option} ${item.value === value ? optionActive : ""}`}
						onClick={() => onChange(item.value)}
					>
						{item.label}
					</button>
				))}
			</div>
		</div>
	)
}
